import { typeActionCreator, valueActionCreator } from "../action_creators";
export var SET_NOTE_TEMPLATES = 'SET_NOTE_TEMPLATES';
export var SET_NOTE_TEMPLATES_CATEGORIES_LOADING = 'SET_NOTE_TEMPLATES_CATEGORIES_LOADING';
export var SET_NOTE_TEMPLATE_CATEGORIES = 'SET_NOTE_TEMPLATE_CATEGORIES';
export var SET_NOTE_TEMPLATE_VARIABLES = 'SET_NOTE_TEMPLATE_VARIABLES';
export var SET_RENDERED_NOTE_TEMPLATE_IS_LOADING = 'SET_RENDERED_NOTE_TEMPLATE_IS_LOADING';
export var SET_RENDERED_NOTE_TEMPLATE_RECEIVED = 'SET_RENDERED_NOTE_TEMPLATE_RECEIVED';
export var SET_RENDERED_NOTE_TEMPLATE_ERROR = 'SET_RENDERED_NOTE_TEMPLATE_ERROR';
export var NOTE_TEMPLATES_FILTER_CLEAR = 'NOTE_TEMPLATES_FILTER_CLEAR';
export var NOTE_TEMPLATES_FILTER_SET_ARCHIVED = 'NOTE_TEMPLATES_FILTER_SET_ARCHIVED';
export var NOTE_TEMPLATES_FILTER_SET_CATEGORIES = 'NOTE_TEMPLATES_FILTER_SET_CATEGORIES';
export var NOTE_TEMPLATES_FILTER_SET_FOR_AGENTS = 'NOTE_TEMPLATES_FILTER_SET_FOR_AGENTS';
export var NOTE_TEMPLATES_FILTER_SET_FOR_STUDENTS = 'NOTE_TEMPLATES_FILTER_SET_FOR_STUDENTS';
export var NOTE_TEMPLATES_FILTER_SET_HIDDEN = 'NOTE_TEMPLATES_FILTER_SET_HIDDEN';
export var NOTE_TEMPLATES_FILTER_SET_RESTRICTED = 'NOTE_TEMPLATES_FILTER_SET_RESTRICTED';
export var NOTE_TEMPLATES_FILTER_SET_SEARCH = 'NOTE_TEMPLATES_FILTER_SET_SEARCH';
export var NOTE_TEMPLATES_FILTER_SET_TAGS = 'NOTE_TEMPLATES_FILTER_SET_TAGS';
export var NOTE_TEMPLATES_FILTER_SET_TEMPLATE_TYPES = 'NOTE_TEMPLATES_FILTER_SET_TEMPLATE_TYPES';
export var NOTE_TEMPLATES_FILTER_SET_VISIBILITY = 'NOTE_TEMPLATES_FILTER_SET_VISIBILITY';
export var NOTE_TEMPLATES_FILTER_SET_VISIBLE = 'NOTE_TEMPLATES_FILTER_SET_VISIBLE';
export var NOTE_TEMPLATES_FILTER_TOGGLE = 'NOTE_TEMPLATES_FILTER_TOGGLE';
export var MULTIPLE_NOTES_SHOW = 'MULTIPLE_NOTES_SHOW';
export var MULTIPLE_NOTES_HIDE = 'MULTIPLE_NOTES_HIDE';
export var MULTIPLE_NOTES_SET_VISIBLE = 'MULTIPLE_NOTES_SET_VISIBLE';
export var MULTIPLE_NOTES_SET_NOTE = 'MULTIPLE_NOTES_SET_NOTE';
export var MULTIPLE_NOTES_UNSET_NOTE = 'MULTIPLE_NOTES_UNSET_NOTE';
export var MULTIPLE_NOTES_SET_TEMPLATE_ID = 'MULTIPLE_NOTES_SET_TEMPLATE_ID';
export var MULTIPLE_NOTES_UNSET_TEMPLATE_ID = 'MULTIPLE_NOTES_UNSET_TEMPLATE_ID';
export var MULTIPLE_NOTES_SET_APPLICATION_IDS = 'MULTIPLE_NOTES_SET_APPLICATION_IDS';
export var MULTIPLE_NOTES_ADD_APPLICATION_ID = 'MULTIPLE_NOTES_ADD_APPLICATION_ID';
export var MULTIPLE_NOTES_REMOVE_APPLICATION_ID = 'MULTIPLE_NOTES_REMOVE_APPLICATION_ID';
export var MULTIPLE_NOTES_CLEAR_APPLICATION_IDS = 'MULTIPLE_NOTES_CLEAR_APPLICATION_IDS';
export var setNoteTemplates = valueActionCreator(SET_NOTE_TEMPLATES);
export var setNoteTemplateCategoriesLoading = valueActionCreator(SET_NOTE_TEMPLATES_CATEGORIES_LOADING);
export var setNoteTemplateCategories = valueActionCreator(SET_NOTE_TEMPLATE_CATEGORIES);
export var setNoteTemplateVariables = valueActionCreator(SET_NOTE_TEMPLATE_VARIABLES);
export var setRenderedNoteTemplateIsLoading = function setRenderedNoteTemplateIsLoading(template_id, application_id) {
  return {
    type: SET_RENDERED_NOTE_TEMPLATE_IS_LOADING,
    template_id: template_id,
    application_id: application_id,
    value: null
  };
};
export var setRenderedNoteTemplateReceived = function setRenderedNoteTemplateReceived(template_id, application_id, value) {
  return {
    type: SET_RENDERED_NOTE_TEMPLATE_RECEIVED,
    template_id: template_id,
    application_id: application_id,
    value: value
  };
};
export var setRenderedNoteTemplateError = function setRenderedNoteTemplateError(template_id, application_id, value) {
  return {
    type: SET_RENDERED_NOTE_TEMPLATE_ERROR,
    template_id: template_id,
    application_id: application_id,
    value: value
  };
};
export var noteTemplatesFilterClear = typeActionCreator(NOTE_TEMPLATES_FILTER_CLEAR);
export var noteTemplatesFilterSetArchived = valueActionCreator(NOTE_TEMPLATES_FILTER_SET_ARCHIVED);
export var noteTemplatesFilterSetCategories = valueActionCreator(NOTE_TEMPLATES_FILTER_SET_CATEGORIES);
export var noteTemplatesFilterSetForAgents = valueActionCreator(NOTE_TEMPLATES_FILTER_SET_FOR_AGENTS);
export var noteTemplatesFilterSetForStudents = valueActionCreator(NOTE_TEMPLATES_FILTER_SET_FOR_STUDENTS);
export var noteTemplatesFilterSetHidden = typeActionCreator(NOTE_TEMPLATES_FILTER_SET_HIDDEN);
export var noteTemplatesFilterSetRestricted = valueActionCreator(NOTE_TEMPLATES_FILTER_SET_RESTRICTED);
export var noteTemplatesFilterSetSearch = valueActionCreator(NOTE_TEMPLATES_FILTER_SET_SEARCH);
export var noteTemplatesFilterSetTags = valueActionCreator(NOTE_TEMPLATES_FILTER_SET_TAGS);
export var noteTemplatesFilterSetTemplateTypes = valueActionCreator(NOTE_TEMPLATES_FILTER_SET_TEMPLATE_TYPES);
export var noteTemplatesFilterSetVisibility = valueActionCreator(NOTE_TEMPLATES_FILTER_SET_VISIBILITY);
export var noteTemplatesFilterSetVisible = typeActionCreator(NOTE_TEMPLATES_FILTER_SET_VISIBLE);
export var noteTemplatesFilterToggle = typeActionCreator(NOTE_TEMPLATES_FILTER_TOGGLE);
export var multipleNotesShow = typeActionCreator(MULTIPLE_NOTES_SHOW);
export var multipleNotesSetVisible = valueActionCreator(MULTIPLE_NOTES_SET_VISIBLE);
export var multipleNotesSetNote = valueActionCreator(MULTIPLE_NOTES_SET_NOTE);
export var multipleNotesUnsetNote = typeActionCreator(MULTIPLE_NOTES_UNSET_TEMPLATE_ID);
export var multipleNotesSetTemplateId = valueActionCreator(MULTIPLE_NOTES_SET_TEMPLATE_ID);
export var multipleNotesUnsetTemplateId = typeActionCreator(MULTIPLE_NOTES_UNSET_TEMPLATE_ID);
export var multipleNotesSetApplicationIds = valueActionCreator(MULTIPLE_NOTES_SET_APPLICATION_IDS);